<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditTurmaModal
      v-if="showCreateEditTurmaModal"
      :turmaId="turmaIdSelected"
      @closeModal="closeCreateEditTurmaModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Turmas</h5>
        <div v-if="getModuleUserByCode('1.01.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Nova Turma"
            @click="createEditTurma()"
          >
            <i class="ri-add-fill align-middle"></i>Nova Turma
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListTurmas :turmas="turmas" @editTurma="createEditTurma" />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListTurmas from '@/components/escola/turmas/ListTurmas.vue'
import CreateEditTurmaModal from '@/components/escola/turmas/CreateEditTurmaModal.vue'

export default {
  name: 'Turmas',

  components: {
    Layout,
    PageHeader,
    CreateEditTurmaModal,
    LoadingData,
    ListTurmas,
  },

  data() {
    return {
      title: 'Turmas',
      items: [
        {
          text: 'Turmas',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditTurmaModal: false,
      turmas: null,
      turmaIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getTurmas() {
      try {
        this.turmas = await this.$store.dispatch('getTurmas')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditTurma(turmaId) {
      this.turmaIdSelected = turmaId || null
      this.showCreateEditTurmaModal = true
    },

    closeCreateEditTurmaModal(loadListTurmas) {
      if (loadListTurmas) {
        this.getTurmas()
      }
      this.showCreateEditTurmaModal = false
    },
  },

  mounted() {
    this.getTurmas()
  },
}
</script>
